import { BillsTableSuggestibleField } from '../types/billsTableRow'

export const isBillsTableFieldSuggestion = <T>(
  field: BillsTableSuggestibleField<T>,
): field is BillsTableSuggestibleField<T> & { suggestion: T } => {
  // eslint-disable-next-line lodash/prefer-is-nil
  return field.suggestion !== undefined && field.suggestion !== null && field.actual === null
}
